import {
  LOGIN,
  REGISTER,
  FORGOT_PASSWORD,
  UBERSUGGEST_OVERVIEW,
  UBERSUGGEST_KEYWORD_IDEAS,
  UBERSUGGEST_CONTENT_IDEAS,
  TRAFFIC_ANALYZER_OVERVIEW,
  SEO_ANALYZER_BACKLINKS,
  TRAFFIC_ANALYZER_KEYWORDS,
  TRAFFIC_ANALYZER_COMPETITORS,
  SEO_ANALYZER_SITE_AUDIT,
  PRICING,
} from '../../consts/location-paths/index.mjs'

/**
 * UBS_META_TAGS is a configuration object that defines meta tags for various routes in the application.
 * Each key represents a route, and its value contains the meta tags to be rendered for that route.
 * @type {Object<string, {tags: Array<{tag: string, text?: string, props?: {name: string, content: string}}>>}>}
 * @example
 * ```tsx
 * {
 *   'home|alerts/:id': {
 *     tags: [
 *       { tag: 'title', text: 'Title Text' },
 *       { tag: 'meta', props: { name: 'description', content: 'Meta description text' } },
 *     ]
 *   }
 * }
 * ```
 */
export const UBS_META_TAGS = {
  [REGISTER]: {
    tags: [
      {
        tag: 'title',
        text: 'register_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'register_meta_description',
        },
      },
    ],
  },

  [LOGIN]: {
    tags: [
      {
        tag: 'title',
        text: 'login_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'login_meta_description',
        },
      },
    ],
  },

  [FORGOT_PASSWORD]: {
    tags: [
      {
        tag: 'title',
        text: 'forgot_password_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'forgot_password_meta_description',
        },
      },
    ],
  },

  [UBERSUGGEST_OVERVIEW]: {
    tags: [
      {
        tag: 'title',
        text: 'overview_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'overview_meta_description',
        },
      },
    ],
  },

  [UBERSUGGEST_KEYWORD_IDEAS]: {
    tags: [
      {
        tag: 'title',
        text: 'keyword_ideas_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'keyword_ideas_meta_description',
        },
      },
    ],
  },

  [UBERSUGGEST_CONTENT_IDEAS]: {
    tags: [
      {
        tag: 'title',
        text: 'content_ideas_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'content_ideas_meta_description',
        },
      },
    ],
  },

  [TRAFFIC_ANALYZER_OVERVIEW]: {
    tags: [
      {
        tag: 'title',
        text: 'traffic_analyzer_overview_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'traffic_analyzer_overview_meta_description',
        },
      },
    ],
  },

  [TRAFFIC_ANALYZER_KEYWORDS]: {
    tags: [
      {
        tag: 'title',
        text: 'traffic_analyzer_keywords_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'traffic_analyzer_keywords_meta_description',
        },
      },
    ],
  },

  [TRAFFIC_ANALYZER_COMPETITORS]: {
    tags: [
      {
        tag: 'title',
        text: 'competitors_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'competitors_meta_description',
        },
      },
    ],
  },

  [SEO_ANALYZER_SITE_AUDIT]: {
    tags: [
      {
        tag: 'title',
        text: 'site_audit_meta_tilte',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'site_audit_meta_description',
        },
      },
    ],
  },

  [SEO_ANALYZER_BACKLINKS]: {
    tags: [
      {
        tag: 'title',
        text: 'backlinks_meta_tilte',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'backlinks_meta_description',
        },
      },
    ],
  },

  [PRICING]: {
    tags: [
      {
        tag: 'title',
        text: 'pricing_meta_title',
      },
      {
        tag: 'meta',
        props: {
          name: 'description',
          content: 'pricing_meta_description',
        },
      },
    ],
  },
}
